<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'sidebar-link',
})
</script>
<template>
  <router-link
    :to="to"
    :target="isBlank ? '_blank' : ''"
  >
    <slot></slot>
  </router-link>
</template>
<script lang="ts" setup name="sidebar-link">
  defineProps({
    to: {
      type: String,
      required: true,
    },
    isBlank: {
      type: Boolean,
      default: false,
    },
  });
</script>
